<template>
  <v-container fluid class="timeslot-selector-view">
    <Breadcrumb :items="breadCrumbs" />
    <v-btn
      class="onboarding-back mb-3"
      color="primary"
      text
      link
      :to="{
        name: 'AddressSelectorView',
        query: { deliveryServiceId: deliveryServiceId }
      }"
    >
      <v-icon small>$arrowBack</v-icon>
      Torna alla scelta del servizio
    </v-btn>
    <TimeslotSelector
      :deliveryServiceId="deliveryServiceId"
      :isNotPopup="true"
      :fetchedCategory="category"
      @submit="timeslotSelected"
    />
  </v-container>
</template>
<style lang="scss">
.timeslot-selector-view {
  .timeslot-selector {
    padding: 0px;
  }
}
</style>
<script>
import TimeslotSelector from "@/components/delivery/TimeslotSelector.vue";
import Breadcrumb from "@/components/navigation/Breadcrumb.vue";
import { mapState } from "vuex";

export default {
  components: { TimeslotSelector, Breadcrumb },
  props: { deliveryServiceId: { type: String, required: false } },
  name: "TimeslotSelectorView",
  computed: {
    ...mapState({
      category: ({ category }) => category.category
    }),
    breadCrumbs() {
      let pathArray = this.$route.path.split("/");
      pathArray.shift();
      const breadCrumbs = [{ href: "/spesa-online", text: "Homepage" }];
      // needed to handle the intermediary entries for nested vue routes
      let breadcrumb = "";
      // let lastIndexFound = 0;

      for (let i = 1; i < pathArray.length; ++i) {
        // from 1 to skip "Area personale"
        breadcrumb = `${breadcrumb}${"/"}${pathArray[i]}`;
        if (
          this.$route.matched[i] &&
          Object.hasOwnProperty.call(this.$route.matched[i], "meta") &&
          Object.hasOwnProperty.call(this.$route.matched[i].meta, "breadCrumb")
        ) {
          breadCrumbs.push({
            href: breadcrumb,
            // i !== 0 && pathArray[i - (i - lastIndexFound)]
            //   ? "/" + pathArray[i - (i - lastIndexFound)] + breadcrumb
            //   : breadcrumb,
            exact: false,
            disabled: i + 1 === pathArray.length,
            text: this.$route.matched[i].meta.breadCrumb || pathArray[i]
          });
          // lastIndexFound = i;
          // breadcrumb = "";
        }
      }
      return breadCrumbs;
    }
  },
  methods: {
    timeslotSelected() {
      if (
        this.$route.query.back &&
        this.$route.query.back != "/onboarding/selezione-servizio" &&
        this.$route.query.back != "/onboarding/selezione-indirizzo" &&
        this.$route.query.back != "/onboarding/selezione-timeslot"
      ) {
        this.$router.push({
          path: this.$route.query.back,
          query: { force: true }
        });
        return;
      } else {
        this.$router.push({
          name: "Home",
          query: { force: true }
        });
      }
    }
  }
};
</script>
